// extracted by mini-css-extract-plugin
module.exports = {"sent":"SessionsTable_sent__2iUia","link":"SessionsTable_link__3r82E"};